import * as z from "zod";

export const CustomAnalyticsQueryScalarValueSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.null(),
]);

export type CustomAnalyticsQueryScalarValue = z.infer<
  typeof CustomAnalyticsQueryScalarValueSchema
>;

export const CustomAnalyticsQueryDatePartSchema = z.enum([
  "day",
  "week",
  "month",
  "quarter",
  "year",
]);

export type CustomAnalyticsQueryDatePart = z.infer<
  typeof CustomAnalyticsQueryDatePartSchema
>;

export const CustomAnalyticsQueryTimeUnitSchema = z.enum([
  "hour",
  "day",
  "dayofweek",
  "dayofyear",
  "week",
  "iso_dayofweek",
  "iso_week",
  "month",
  "quarter",
  "year",
]);

export type CustomAnalyticsQueryTimeUnit = z.infer<
  typeof CustomAnalyticsQueryTimeUnitSchema
>;

export const CustomAnalyticsQueryComparisonOperatorSchema = z.enum([
  "eq",
  "neq",
  "gt",
  "gte",
  "lt",
  "lte",
  "like",
  "ilike",
  "in",
  "not_in",
  "is_null",
  "is_not_null",
  "is_distinct_from",
  // AST spelling of the existing array_contains plan function; conditions can
  // only be and/comparison/not/or, so containment has to ride an operator.
  "array_contains",
]);

export type CustomAnalyticsQueryComparisonOperator = z.infer<
  typeof CustomAnalyticsQueryComparisonOperatorSchema
>;

export const CustomAnalyticsQuerySortDirectionSchema = z.enum(["asc", "desc"]);

export type CustomAnalyticsQuerySortDirection = z.infer<
  typeof CustomAnalyticsQuerySortDirectionSchema
>;
